/*
 * Prenotazione servizi officina B.I.G. Cars — componente condiviso.
 *
 * Un solo file per tutti i prodotti officina a preventivo (freni, cambio
 * gomme, batteria, diagnosi, climatizzatore, distribuzione, frizione e
 * cambio, controllo generale). Quello che cambia da un prodotto all'altro e'
 * soltanto lo service_slug impostato nel template: esigenze, servizi
 * aggiuntivi e canali arrivano da /service.php, cioe' dal gestionale.
 *
 * Perche' le opzioni non stanno qui dentro: se le tenesse il tema, il
 * browser potrebbe mandare un codice che il gestionale non conosce e la
 * differenza si scoprirebbe solo al momento del preventivo. Con la lista
 * servita dall'API, quello che il cliente vede e quello che il server
 * accetta sono la stessa cosa.
 *
 * Il tagliando NON usa questo componente: ha un percorso a pagamento suo
 * (bigcars-tagliando-booking.js) che resta separato.
 */
(function () {
  'use strict';

  var ROOT = '[data-bc-officina]';
  /* Chi ha chiesto meno movimento al sistema non deve vedere le schermate
     scorrere: si passa da una all'altra senza transizione. */
  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function q(root, s) { return root.querySelector(s); }
  function qa(root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  function clean(v) { return String(v == null ? '' : v).trim(); }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'bc-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }
  function escapeHtml(v) {
    var d = document.createElement('div');
    d.textContent = String(v == null ? '' : v);
    return d.innerHTML;
  }
  function localDate(date) {
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }
  function prettyDate(value) {
    if (!value) return '';
    var p = value.split('-');
    return new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
      .format(new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2])));
  }
  /* Prezzo in euro nel formato italiano: 7.9 -> "€ 7,90". */
  function euro(value) {
    return '€ ' + Number(value).toFixed(2).replace('.', ',');
  }

  /* Servizi aggiuntivi alternativi fra loro: selezionandone uno, l'altro
     del gruppo si deseleziona. Solo i codici del gestionale, i value del
     form non cambiano. */
  var EXTRAS_EXCLUSIVE_GROUPS = [
    ['lavaggio_esterno', 'lavaggio_completo']
  ];

  function Booking(root) {
    this.root = root;
    this.form = q(root, '[data-form]');
    this.apiBase = clean(root.dataset.apiBase).replace(/\/$/, '');
    this.token = clean(root.dataset.publicToken);
    this.slug = clean(root.dataset.serviceSlug);
    this.productId = clean(root.dataset.productId);
    this.panels = qa(root, '[data-panel]');
    this.steps = ['reason', 'schedule', 'details', 'review'];
    this.step = 0;
    this.slot = null;
    this.submitting = false;
    this.closed = [6, 7];
    this.options = null;
    this.abort = null;
    /* Minuti aggiuntivi gia' applicati alla ricerca degli orari: serve a
       ricaricare la disponibilita' solo quando cambiano davvero. */
    this.appliedExtraMinutes = 0;
    /* Una chiave per tentativo: se il cliente reinvia dopo un errore di rete
       il gestionale riconosce la stessa richiesta invece di crearne due. */
    this.key = uuid();
    /* Solo presentazione (layout premium): immagini e testi sostitutivi per
       le esigenze, scritti dal tema. I codici inviati restano quelli del
       gestionale; senza mappa il markup e' identico a prima. */
    this.meta = this.readMeta();
    /* Passaggio 3 ridisegnato (solo layout premium): riepilogo, card per
       canali ed extra, contatore note. Riconosciuto dal markup, non dalla
       classe: senza [data-recap] il passaggio 3 rende come prima. */
    this.premiumDetails = !!q(root, '[data-recap]');
    /* Calendario mensile (solo layout premium): UI che scrive nell'input
       data. Se il markup non c'e' (layout classico) resta l'input nativo. */
    this.calendar = q(root, '[data-calendar]');
    this.month = null;
    this.msgPickDate = clean(root.dataset.msgPickDate) || 'Scegli una data per vedere gli orari.';
    this.msgNoSlots = clean(root.dataset.msgNoSlots) || 'Nessun posto disponibile per questo giorno.';
    /* Campi specifici dell'intervento (passaggio 1): valori gia' scritti dal
       cliente, tenuti fuori dal DOM cosi' sopravvivono al ridisegno del
       blocco e al vai/torna fra i passaggi. */
    this.serviceState = {};
    /* Esigenze da mostrare come card (impostazione del tema). Vuoto = tutte,
       cioe' il comportamento di sempre. Le altre restano nel DOM e nello
       stato — il gestionale continua ad accettarle — ma non si vedono e non
       si raggiungono da tastiera: le seleziona solo chi apre il modulo
       passando un'esigenza precisa (vedi start()). */
    this.visibleReasons = clean(root.dataset.visibleReasons).split(',')
      .map(function (code) { return clean(code); })
      .filter(function (code) { return code !== ''; });
    /* Modulo differito (impostazione del tema): la sezione e' in pagina e
       carica le sue opzioni come sempre, ma resta nascosta finche' qualcuno
       non la apre con start(). Lo usa la pagina freni, dove a scegliere il
       percorso e' la landing sopra il modulo. Senza l'attributo il modulo e'
       visibile da subito, cioe' come su tutti gli altri servizi. */
    this.deferred = root.dataset.deferred === '1';
    /* reveal() spegne deferred, ma serve ricordare come la sezione e' nata:
       solo un modulo differito ha qualcuno davanti che fa scegliere, e solo
       in quel caso ha senso saltare il passaggio della scelta. */
    this.startsDeferred = this.deferred;
    /* Modalita' wizard: il modulo e' la seconda schermata di un percorso che
       comincia da un'altra sezione (pagina freni). Cambia solo la messa in
       scena — scorrimento laterale invece di apertura in verticale — e vale
       solo dove c'e' davvero una schermata prima: gli altri servizi officina
       restano com'erano. */
    this.wizard = this.startsDeferred;
    if (this.wizard) root.classList.add('bc-ofb--wizard');
    /* Direzione dell'ultimo spostamento: serve al CSS per far entrare il
       pannello dal lato giusto, come in un'app. */
    this.goingBack = false;
    /* Passaggio 1 saltato: la scelta e' gia' stata fatta fuori dal modulo
       (la landing freni) e rifarla qui sarebbe la stessa domanda due volte.
       Lo decide applyStart(), non il tema: se l'intervento scelto richiede
       dati che si chiedono al passaggio 1, il passaggio resta. */
    this.skipReason = false;
    /* Richiesta arrivata prima che le esigenze fossero disegnate: si tiene da
       parte e si applica appena la lista del gestionale e' in pagina. */
    this.pendingStart = null;
    /* Suffisso per id e name dei campi generati: due sezioni sulla stessa
       pagina non devono condividere lo stesso gruppo di radio. */
    this.fieldUid = (this.productId || '') + '-' + Math.random().toString(36).slice(2, 8);
    /* Strati a tutto schermo: i riferimenti vanno presi prima di spostarli
       fuori dalla sezione, perche' dopo non sono piu' discendenti di root. */
    this.fs = {
      sending: q(root, '[data-sending]'),
      done: q(root, '[data-request-done]'),
      codeBox: q(root, '[data-booking-code-box]'),
      code: q(root, '[data-booking-code]'),
      mailEmail: q(root, '[data-done-email]'),
      mailWhatsapp: q(root, '[data-done-whatsapp]')
    };
    this.mountLayers();
    this.bind();
    this.guardDeferred();
    this.init();
  }

  /*
   * Rete di sicurezza del modulo differito.
   *
   * Differito vuol dire invisibile finche' qualcun altro non lo apre. Se
   * quel qualcuno non c'e' — la sezione che lo comanda non e' stata caricata
   * sul tema, o e' stata tolta dal template — il cliente si troverebbe una
   * pagina vuota e nessun modo di prenotare. Meglio un modulo in piu' che un
   * servizio irraggiungibile: se al primo giro di eventi nessuno si e'
   * dichiarato controllore (vedi data-bc-controlled), il modulo si mostra da
   * solo e la pagina torna a funzionare come un normale servizio officina.
   *
   * setTimeout(0) e non DOMContentLoaded: serve solo lasciar girare gli altri
   * script gia' in coda, fra cui quello che fa la dichiarazione.
   */
  Booking.prototype.guardDeferred = function () {
    var self = this;
    if (!this.deferred) return;
    setTimeout(function () {
      if (!self.deferred) return;
      if (self.root.dataset.bcControlled === '1') return;
      self.reveal();
    }, 0);
  };

  /*
   * Apertura del modulo dall'esterno (oggi: le card della pagina freni).
   *
   * Si passa sempre da qui e non dal DOM: chi apre il modulo dichiara cosa ha
   * scelto il cliente (esigenza + eventuale sintomo) e il resto - selezione
   * del radio reale, campi dell'intervento, pulsante "Continua" - lo fa il
   * booking con gli stessi handler del clic manuale. Cosi' il payload inviato
   * e' identico a quello di chi compila il passaggio 1 a mano.
   *
   * request = { reason: 'codice', service_data: { chiave: 'valore' } }
   */
  Booking.prototype.start = function (request) {
    this.reveal();
    this.pendingStart = request && typeof request === 'object' ? request : {};
    /* Senza opzioni il radio non esiste ancora: applyStart() viene richiamata
       da renderOptions appena la lista arriva dal gestionale. */
    if (this.options) this.applyStart();
  };

  Booking.prototype.reveal = function () {
    if (!this.deferred) return;
    this.deferred = false;
    this.root.removeAttribute('data-deferred');
    this.root.removeAttribute('aria-hidden');
    this.root.removeAttribute('inert');
    if (!this.wizard) return;
    /* Entra da destra, come la schermata successiva di un configuratore. */
    var root = this.root;
    animateScreen(root, 'bc-screen-in-right');
    /* La classe va tolta a transizione finita: finche' resta, la regola che
       impedisce al pannello di scorrere dentro una schermata che sta gia'
       scorrendo spegnerebbe anche le animazioni dei passaggi successivi. */
    whenAnimationEnds(root, function () { root.classList.remove('bc-screen-in-right'); }, 300);
  };

  /*
   * Porta la vista dove il contenuto e' appena cambiato, senza scorrimento
   * animato.
   *
   * L'animazione dice gia' che si sta passando a un'altra schermata: farla
   * seguire da uno scroll morbido significherebbe raccontare due volte la
   * stessa cosa e far sembrare lungo un passaggio che dura mezzo secondo.
   * Qui si riallinea la pagina in un fotogramma, mentre l'occhio e' sulla
   * schermata che entra. Se la zona e' gia' sotto gli occhi non si tocca
   * niente: muovere la pagina quando non serve e' il salto che si vuole
   * evitare.
   */
  function snapIntoView(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top;
    /* Margine per l'header fisso del tema, letto dal CSS della sezione
       cosi' non c'e' un secondo numero da tenere allineato a mano. */
    var gap = parseInt(getComputedStyle(el).scrollMarginTop, 10);
    if (!(gap >= 0)) gap = 100;
    if (top >= 0 && top <= gap + 40) return;
    window.scrollTo({ top: window.scrollY + top - gap, behavior: 'auto' });
  }

  /*
   * Fine animazione con rete di sicurezza.
   *
   * animationend non arriva se l'elemento viene nascosto, se la scheda passa
   * in secondo piano o se il CSS non e' quello previsto: senza il timer la
   * schermata resterebbe bloccata a meta' transizione, cioe' invisibile e
   * irraggiungibile. Il seguito deve partire comunque.
   */
  function whenAnimationEnds(el, done, maxMs) {
    var fatto = false;
    var fine = function () {
      if (fatto) return;
      fatto = true;
      el.removeEventListener('animationend', fine);
      done();
    };
    el.addEventListener('animationend', fine);
    /* Il margine e' legato alla durata dell'animazione, non un numero fisso:
       con una scheda in secondo piano il browser non fa girare le animazioni
       e animationend non arriva mai, quindi questo e' il tempo che il cliente
       aspetta davvero prima di vedere la schermata successiva. */
    setTimeout(fine, (maxMs || 300) + 80);
  }

  /* Riavvia un'animazione anche se la classe c'era gia': senza il reflow il
     browser non la considera un cambiamento e l'animazione non riparte. */
  function animateScreen(el, name) {
    if (!el) return;
    el.classList.remove('bc-screen-in-right', 'bc-screen-in-left', 'bc-screen-out-left', 'bc-screen-out-right');
    void el.offsetWidth;
    el.classList.add(name);
  }

  /* Primo passaggio ancora raggiungibile: 0 di norma, 1 quando la scelta e'
     gia' stata fatta fuori dal modulo. Unico punto che lo decide, cosi'
     "Indietro" e il riepilogo non possono dare risposte diverse. */
  Booking.prototype.minStep = function () { return this.skipReason ? 1 : 0; };

  /* Uscita dal modulo verso la pagina che lo ha aperto: il modulo torna
     nascosto e chi lo comanda riporta il cliente alla scelta. Se nessuno
     ascolta, il modulo resta dov'e' e non succede nulla di rotto. */
  Booking.prototype.exitToStart = function () {
    var self = this;
    if (!this.startsDeferred || this.deferred) return;
    this.clearAlert();

    var hide = function () {
      self.deferred = true;
      self.root.classList.remove('bc-screen-out-right');
      self.root.setAttribute('data-deferred', '1');
      /* Schermata fuori scena: non deve restare leggibile da screen reader
         ne' raggiungibile col tab mentre si guarda l'altra. */
      self.root.setAttribute('aria-hidden', 'true');
      self.root.setAttribute('inert', '');
      /* L'altra schermata rientra solo adesso: due schermate insieme, anche
         per un istante, romperebbero l'illusione dello switch. */
      self.root.dispatchEvent(new CustomEvent('bc-ofb:exit', { bubbles: true }));
    };

    if (!this.wizard || REDUCED_MOTION) { hide(); return; }
    /* Si torna indietro, quindi si esce dal lato opposto a quello da cui si
       era entrati. */
    animateScreen(this.root, 'bc-screen-out-right');
    whenAnimationEnds(this.root, hide, 200);
  };

  Booking.prototype.applyStart = function () {
    var request = this.pendingStart;
    if (!request) return;
    this.pendingStart = null;

    /* Dati del sintomo: entrano nello stato dei campi dell'intervento, cioe'
       nello stesso posto in cui finirebbero se il cliente li avesse scelti in
       un campo visibile.

       Prima pero' si azzerano tutti i campi nascosti del servizio. Chi apre
       il modulo dichiara la situazione intera, non una correzione di quella
       precedente: senza questa pulizia un cliente che guarda le cause della
       spia e poi sceglie "Sostituzione pastiglie" manderebbe in officina il
       sintomo di prima, che non ha piu' indicato. I campi visibili non si
       toccano: quelli li ha scritti lui e deve ritrovarli. */
    var state = this.serviceState;
    ((this.options && this.options.service_fields) || []).forEach(function (field) {
      if (field.hidden === true) delete state[field.key];
    });

    var data = request.service_data;
    if (data && typeof data === 'object') {
      Object.keys(data).forEach(function (key) {
        if (clean(data[key])) state[key] = clean(data[key]);
      });
    }

    var code = clean(request.reason);
    var input = code ? q(this.root, 'input[name="reason"][value="' + code + '"]') : null;
    if (input && !input.checked) {
      input.checked = true;
      /* Stesso evento del clic dell'utente: campi dell'intervento, nota di
         ambito e pulsante "Continua" si aggiornano da soli. */
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      this.renderServiceFields();
      this.renderScopeNote();
      this.updateReasonGate();
    }

    /*
     * Chi apre il modulo dall'esterno ha gia' fatto scegliere: ripresentare
     * "Come possiamo aiutarti?" significherebbe chiedere due volte la stessa
     * cosa. Si parte quindi da data e ora.
     *
     * Non sempre, pero': alcuni interventi hanno campi obbligatori che si
     * compilano proprio al passaggio 1 (per il cambio gomme la misura degli
     * pneumatici). Se quei campi non sono gia' soddisfatti, saltare il
     * passaggio porterebbe a una richiesta incompleta: in quel caso il
     * passaggio resta e il cliente lo vede, con l'esigenza gia' selezionata.
     */
    if (this.startsDeferred && input && this.reasonStepReady()) {
      this.enterSkipReason();
      this.go(1);
      return;
    }
    this.go(0);
  };

  /*
   * Modalita' "scelta gia' fatta": il passaggio 1 esce dal percorso.
   *
   * Il pannello resta nel DOM e il radio selezionato resta la fonte di
   * verita' del payload — quello che si invia non cambia di una virgola —
   * ma non e' piu' una tappa: sparisce dallo stepper, i passaggi si
   * rinumerano e "Indietro" riporta alla pagina, non a una scelta.
   */
  Booking.prototype.enterSkipReason = function () {
    var self = this;
    if (this.skipReason) { this.renderServiceBadge(); return; }
    this.skipReason = true;
    this.steps = ['reason', 'schedule', 'details', 'review'];

    this.root.classList.add('bc-ofb--no-reason-step');

    /* Stepper: via la tappa "Esigenza" e numeri da 1 a 3. */
    var items = qa(this.root, '[data-progress]').filter(function (li) {
      return li.dataset.progress !== 'reason';
    });
    var first = q(this.root, '[data-progress="reason"]');
    if (first) { first.hidden = true; first.setAttribute('aria-hidden', 'true'); }
    items.forEach(function (li, i) {
      var num = q(li, 'span');
      if (num) num.textContent = String(i + 1);
    });

    /* "Passaggio N di 4" -> "di 3". Con il layout premium queste righe sono
       nascoste dal CSS, ma il layout classico le mostra e devono dire il
       vero. */
    qa(this.root, '.bc-ofb__step').forEach(function (p) {
      var panel = p.closest('[data-panel]');
      if (!panel) return;
      var i = self.steps.indexOf(panel.dataset.panel);
      if (i > 0) p.textContent = 'Passaggio ' + i + ' di 3';
    });

    /* "Indietro" del passaggio data e ora: non c'e' piu' un passaggio
       precedente dentro il modulo, quindi riporta alla pagina da cui la
       scelta e' arrivata invece di sparire e lasciare il cliente dentro un
       flusso senza uscita. */
    var back = q(q(this.root, '[data-panel="schedule"]'), '[data-back]');
    if (back) {
      back.textContent = 'Cambia servizio';
      back.dataset.exitToStart = '1';
    }

    this.renderServiceBadge();
  };

  /*
   * Riepilogo del servizio scelto in cima al passaggio data e ora: dice cosa
   * si sta prenotando senza essere un posto in cui riscegliere. Niente radio,
   * niente card: una riga e, dove esiste, il prezzo.
   */
  Booking.prototype.renderServiceBadge = function () {
    var badge = q(this.root, '[data-service-badge]');
    if (!badge) return;
    var reason = this.reasonData();
    if (!reason) { badge.hidden = true; return; }
    var price = Number(reason.price_eur) > 0
      ? '<b class="bc-ofb__badge-price">' + escapeHtml(euro(reason.price_eur)) + '</b>'
      : '';
    badge.innerHTML = '<span class="bc-ofb__badge-label">Servizio selezionato</span>'
      + '<strong class="bc-ofb__badge-value">' + escapeHtml(reason.label) + price + '</strong>';
    badge.hidden = false;
  };

  Booking.prototype.bind = function () {
    var self = this;
    /* Unico ingresso dall'esterno: un evento sulla sezione, cosi' chi apre il
       modulo non ha bisogno di conoscere l'istanza ne' il momento in cui e'
       stata creata. */
    this.root.addEventListener('bc-ofb:start', function (e) { self.start(e.detail); });
    qa(this.root, '[data-next]').forEach(function (b) { b.addEventListener('click', function () { self.next(); }); });
    qa(this.root, '[data-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        /* Con il passaggio 1 fuori dal percorso, "Indietro" sul primo
           passaggio visibile non ha dove tornare dentro il modulo: riporta
           alla pagina che ha fatto scegliere. */
        if (b.dataset.exitToStart === '1' && self.skipReason) { self.exitToStart(); return; }
        self.go(Math.max(self.minStep(), self.step - 1));
      });
    });
    q(this.root, '[data-date]').addEventListener('change', function () { self.loadSlots(this.value); });
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.submit(); });
    /* "Modifica" nel riepilogo del passaggio 3: torna al passaggio indicato
       senza toccare lo stato (esigenza, data e orario restano nel DOM). */
    qa(this.root, '[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () {
        var index = self.steps.indexOf(b.dataset.goto);
        if (index !== -1 && index < self.step) self.go(index);
      });
    });
    var noteCount = q(this.root, '[data-note-count]');
    if (noteCount && this.form.elements.customer_note) {
      var note = this.form.elements.customer_note;
      var max = Number(note.maxLength) > 0 ? Number(note.maxLength) : 600;
      var updateCount = function () { noteCount.textContent = note.value.length + '/' + max; };
      note.addEventListener('input', updateCount);
      updateCount();
    }
    if (this.calendar) {
      q(this.calendar, '[data-month-prev]').addEventListener('click', function () { self.changeMonth(-1); });
      q(this.calendar, '[data-month-next]').addEventListener('click', function () { self.changeMonth(1); });
      q(this.calendar, '[data-calendar-days]').addEventListener('click', function (e) {
        var b = e.target instanceof Element ? e.target.closest('[data-iso]') : null;
        if (!b || b.disabled) return;
        self.selectDay(b.dataset.iso);
      });
    }
  };

  /* ---------- Calendario (pattern del tagliando, stato in questo widget) ---------- */

  Booking.prototype.dateBounds = function () {
    var input = q(this.root, '[data-date]');
    var p = function (v) { var a = v.split('-'); return new Date(Number(a[0]), Number(a[1]) - 1, Number(a[2])); };
    return { min: p(input.min), max: p(input.max) };
  };

  Booking.prototype.changeMonth = function (direction) {
    if (!this.calendar) return;
    var b = this.dateBounds();
    var first = new Date(b.min.getFullYear(), b.min.getMonth(), 1);
    var last = new Date(b.max.getFullYear(), b.max.getMonth(), 1);
    var candidate = new Date(this.month.getFullYear(), this.month.getMonth() + direction, 1);
    if (candidate < first || candidate > last) return;
    this.month = candidate;
    this.renderCalendar();
  };

  Booking.prototype.renderCalendar = function () {
    if (!this.calendar) return;
    var b = this.dateBounds();
    if (!this.month) this.month = new Date(b.min.getFullYear(), b.min.getMonth(), 1);
    var month = this.month;
    var first = new Date(b.min.getFullYear(), b.min.getMonth(), 1);
    var last = new Date(b.max.getFullYear(), b.max.getMonth(), 1);
    var selected = q(this.root, '[data-date]').value;
    var closed = this.closed;
    var labelFmt = new Intl.DateTimeFormat('it-IT', { dateStyle: 'full' });

    q(this.calendar, '[data-month-label]').textContent = new Intl.DateTimeFormat('it-IT', { month: 'long', year: 'numeric' }).format(month);
    q(this.calendar, '[data-month-prev]').disabled = month <= first;
    q(this.calendar, '[data-month-next]').disabled = month >= last;

    var grid = q(this.calendar, '[data-calendar-days]');
    grid.innerHTML = '';
    var firstWeekday = (month.getDay() + 6) % 7;
    var count = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate();
    var prevCount = new Date(month.getFullYear(), month.getMonth(), 0).getDate();
    var cells = [];
    /* Giorni del mese precedente e successivo: solo riempitivi attenuati. */
    for (var i = firstWeekday - 1; i >= 0; i--) cells.push({ outside: true, day: prevCount - i });
    for (var d = 1; d <= count; d++) cells.push({ day: d, date: new Date(month.getFullYear(), month.getMonth(), d) });
    var tail = (7 - (cells.length % 7)) % 7;
    for (var t = 1; t <= tail; t++) cells.push({ outside: true, day: t });

    cells.forEach(function (c) {
      if (c.outside) {
        var s = document.createElement('span');
        s.className = 'bc-ofb__day is-outside';
        s.textContent = String(c.day);
        grid.appendChild(s);
        return;
      }
      var iso = localDate(c.date);
      var wd = c.date.getDay() === 0 ? 7 : c.date.getDay();
      var isClosed = closed.indexOf(wd) !== -1;
      var out = c.date < b.min || c.date > b.max;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bc-ofb__day' + (isClosed && !out ? ' is-closed' : '') + (selected === iso ? ' is-selected' : '');
      btn.textContent = String(c.day);
      btn.dataset.iso = iso;
      btn.disabled = out || isClosed;
      if (btn.disabled) btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-pressed', selected === iso ? 'true' : 'false');
      btn.setAttribute('aria-label', labelFmt.format(c.date) + (isClosed ? ', officina chiusa' : ''));
      grid.appendChild(btn);
    });
  };

  Booking.prototype.selectDay = function (iso) {
    var input = q(this.root, '[data-date]');
    if (input.value === iso) return;
    input.value = iso;
    this.renderCalendar();
    this.loadSlots(iso);
  };

  Booking.prototype.renderDuration = function (minutes) {
    var box = q(this.root, '[data-duration]');
    if (!box) return;
    minutes = Number(minutes) || 0;
    if (minutes <= 0) { box.hidden = true; return; }
    var h = Math.floor(minutes / 60);
    var m = minutes % 60;
    q(box, '[data-duration-value]').textContent = h && m ? h + ' h ' + m + ' min' : h ? h + (h === 1 ? ' ora' : ' ore') : m + ' min';
    box.hidden = false;
  };

  Booking.prototype.readMeta = function () {
    var node = q(this.root, '[data-reason-meta]');
    var meta = { intro: '', reasons: {}, copy: {}, extras: {}, prices: {} };
    if (node) {
      try {
        var parsed = JSON.parse(node.textContent || '{}');
        meta.intro = clean(parsed.intro);
        meta.reasons = parsed.reasons && typeof parsed.reasons === 'object' ? parsed.reasons : {};
        meta.copy = parsed.copy && typeof parsed.copy === 'object' ? parsed.copy : {};
      } catch (e) { /* mappa malformata: si rende senza immagini */ }
    }
    /* Immagini dei servizi aggiuntivi (passaggio 3), stessa logica. */
    var details = q(this.root, '[data-details-meta]');
    if (details) {
      try {
        var parsedDetails = JSON.parse(details.textContent || '{}');
        meta.extras = parsedDetails.extras && typeof parsedDetails.extras === 'object' ? parsedDetails.extras : {};
      } catch (e) { /* idem: card senza immagine */ }
    }
    /* Prezzi dei servizi aggiuntivi (IVA inclusa), configurati nella sezione
       del tema. Solo presentazione: il backend riceve i codici, non i prezzi. */
    var prices = q(this.root, '[data-extras-prices]');
    if (prices) {
      try {
        var parsedPrices = JSON.parse(prices.textContent || '{}');
        Object.keys(parsedPrices || {}).forEach(function (code) {
          var value = Number(parsedPrices[code]);
          if (isFinite(value) && value > 0) meta.prices[code] = value;
        });
      } catch (e) { /* mappa malformata: card senza prezzo */ }
    }
    return meta;
  };

  Booking.prototype.extraPrice = function (code) {
    var value = (this.meta.prices || {})[code];
    return isFinite(value) && value > 0 ? Number(value) : null;
  };

  Booking.prototype.init = async function () {
    var input = q(this.root, '[data-date]');
    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    input.min = localDate(tomorrow);
    var max = new Date();
    max.setMonth(max.getMonth() + 4);
    input.max = localDate(max);

    this.renderCalendar();

    if (!this.apiBase || !this.token || !this.slug) {
      this.alert('Configurazione incompleta: contatta B.I.G. Cars.');
      return;
    }

    try {
      var data = await this.api('/service.php?service_slug=' + encodeURIComponent(this.slug));
      if (data.workshop && Array.isArray(data.workshop.closed_weekdays)) {
        this.closed = data.workshop.closed_weekdays.map(Number);
        this.renderCalendar();
      }
      /* Durata reale del servizio; availability.php la aggiorna poi con gli extra. */
      if (data.service) this.renderDuration(data.service.duration_minutes);
      if (!data.options || !Array.isArray(data.options.reasons) || !data.options.reasons.length) {
        this.alert('Questo servizio non e configurato per la prenotazione online. Contattaci per fissare un appuntamento.');
        return;
      }
      this.options = data.options;
      this.renderOptions();
    } catch (e) {
      this.alert(this.errorMessage(e));
    }
  };

  /* Esigenze, extra e canali disegnati sulla risposta del gestionale. */
  Booking.prototype.renderOptions = function () {
    var self = this;
    var options = this.options;

    var intro = q(this.root, '[data-reason-intro]');
    if (intro && clean(options.intro)) intro.textContent = options.intro;
    if (intro && this.meta.intro) intro.textContent = this.meta.intro;

    var loader = q(this.root, '[data-options-loading]');
    if (loader) loader.hidden = true;

    var reasons = q(this.root, '[data-reasons]');
    var meta = this.meta;
    reasons.innerHTML = '<legend class="bc-ofb__sr-only">Tipo di richiesta</legend>' + options.reasons.map(function (reason) {
      var media = meta.reasons[reason.code];
      var hint = clean(meta.copy[reason.code]) || clean(reason.hint);
      /* Prezzo del servizio, quando il gestionale ne dichiara uno (oggi solo
         la diagnosi freni). Non e' un preventivo: e' quanto costa quella voce,
         scritto sulla card perche' il cliente lo legga prima di sceglierla. */
      var price = Number(reason.price_eur) > 0
        ? '<b class="bc-ofb__choice-price">' + escapeHtml(euro(reason.price_eur)) + '</b>'
        : '';
      var text = '<strong>' + escapeHtml(reason.label) + price + '</strong>' + (hint ? '<small>' + escapeHtml(hint) + '</small>' : '');
      var body = media && clean(media.src)
        ? '<span class="bc-ofb__choice-media"><img src="' + escapeHtml(media.src) + '"'
          + (clean(media.srcset) ? ' srcset="' + escapeHtml(media.srcset) + '" sizes="(max-width: 749px) 88px, 160px"' : '')
          + ' alt="' + escapeHtml(media.alt) + '" width="480" height="480" loading="lazy" decoding="async"></span>'
          + '<span class="bc-ofb__choice-text">' + text + '</span>'
          + '<span class="bc-ofb__choice-check" aria-hidden="true"></span>'
        : text;
      return '<label' + (media ? ' class="bc-ofb__choice--media"' : '') + '><input type="radio" name="reason" value="' + escapeHtml(reason.code) + '" data-scope="' + escapeHtml(reason.scope) + '">'
        + '<span>' + body + '</span></label>';
    }).join('');
    /* Immagine mappata ma non ancora caricata su Shopify: il file risponde
       404. Meglio togliere l'immagine e lasciare il riquadro vuoto (che
       conserva le sue dimensioni) che mostrare l'icona di immagine rotta. */
    qa(reasons, '.bc-ofb__choice-media img').forEach(function (img) {
      img.addEventListener('error', function () {
        var wrap = img.parentNode;
        if (wrap && wrap.classList) wrap.classList.add('is-empty');
        img.remove();
      });
    });
    qa(reasons, 'input[name="reason"]').forEach(function (i) {
      i.addEventListener('change', function () {
        self.renderServiceFields();
        self.renderScopeNote();
        self.updateReasonGate();
      });
    });
    this.applyReasonVisibility();
    this.renderServiceFields();
    this.updateReasonGate();
    /* Richiesta arrivata mentre le opzioni erano ancora in volo (il cliente
       clicca una card della landing prima che /service.php risponda): adesso
       il radio esiste e si puo' applicare. */
    if (this.pendingStart) this.applyStart();

    var extras = q(this.root, '[data-extras]');
    var extrasCard = extras.closest('[data-extras-card]');
    if (Array.isArray(options.extras) && options.extras.length) {
      extras.innerHTML = this.premiumDetails
        ? this.extrasCardsMarkup(options.extras)
        : '<legend>Vuoi aggiungere altro alla richiesta?</legend>' + options.extras.map(function (extra) {
          var price = self.extraPrice(extra.code);
          return '<label><input type="checkbox" name="extras" value="' + escapeHtml(extra.code) + '"> '
            + escapeHtml(extra.label)
            + (clean(extra.hint) ? ' <small>&middot; ' + escapeHtml(extra.hint) + '</small>' : '')
            + (price !== null ? ' <b class="bc-ofb__extra-price">+ ' + escapeHtml(euro(price)) + '</b>' : '')
            + '</label>';
        }).join('');
      /* Se un extra allunga il lavoro, cambiano gli orari disponibili:
         la disponibilita' va richiesta di nuovo al gestionale. */
      qa(extras, 'input[name="extras"]').forEach(function (i) {
        i.addEventListener('change', function () {
          self.applyExtrasExclusion(i);
          self.onExtrasChanged();
        });
      });
    } else {
      extras.hidden = true;
      if (extrasCard) extrasCard.hidden = true;
    }

    var channels = q(this.root, '[data-channels]');
    var channelList = Array.isArray(options.channels) && options.channels.length
      ? options.channels
      : [{ code: 'email', label: 'Email', automatic: true }];
    channels.innerHTML = (this.premiumDetails
      ? this.channelCardsMarkup(channelList)
      : '<legend>Dove vuoi ricevere le comunicazioni?</legend>' + channelList.map(function (channel, index) {
        return '<label><input type="radio" name="channel" value="' + escapeHtml(channel.code) + '"' + (index === 0 ? ' checked' : '')
          + ' data-requires-phone="' + (channel.requires_phone ? '1' : '0') + '"> ' + escapeHtml(channel.label) + '</label>';
      }).join(''))
      + '<p class="bc-ofb__channel-note" data-channel-note></p>';
    qa(channels, 'input[name="channel"]').forEach(function (i) {
      i.addEventListener('change', function () { self.updateChannel(); });
    });
    this.updateChannel();
  };

  /* Misura pneumatici in forma canonica "205/55 R16" quando il valore e'
     riconoscibile. Non e' una validazione: un formato diverso ma leggibile
     passa cosi' com'e', perche' meglio un dato comprensibile in officina che
     una misura corretta d'ufficio e sbagliata. Stessa regola del gestionale
     (bc_workshop_normalize_tire_size), che resta l'ultima parola. */
  function normalizeTireSize(raw) {
    var value = clean(raw).replace(/\s+/g, ' ');
    if (!value) return '';
    var upper = value.toUpperCase();
    var m = upper.match(/^(\d{2,3})\s*\/\s*(\d{2,3})\s*(ZR|RF|R)\s*(\d{2}(?:[.,]\d)?)$/);
    if (m) return m[1] + '/' + m[2] + ' ' + m[3] + m[4].replace(',', '.');
    m = upper.match(/^(\d{2,3})\s*\/\s*(\d{2,3})\s+(\d{2}(?:[.,]\d)?)$/);
    if (m) return m[1] + '/' + m[2] + ' R' + m[3].replace(',', '.');
    return value;
  }

  /* ---------- Campi specifici dell'intervento (passaggio 1) ---------- */
  /*
   * Alcuni interventi hanno bisogno di due informazioni in piu' per poter
   * essere preventivati (per il cambio gomme: misura, cerchi, fascia). Non
   * sono un passaggio in piu' ne' un configuratore: compaiono sotto la
   * griglia solo per l'esigenza che li richiede e spariscono cambiando scelta.
   *
   * La definizione arriva dal gestionale (options.service_fields), come le
   * esigenze e gli extra: i servizi che non ne hanno non disegnano nulla e
   * restano identici a prima.
   */

  Booking.prototype.serviceFieldsFor = function (code) {
    var list = (this.options && this.options.service_fields) || [];
    if (!code) return [];
    return list.filter(function (f) {
      return Array.isArray(f.when_reason) && f.when_reason.indexOf(code) !== -1;
    });
  };

  Booking.prototype.currentServiceFields = function () {
    var node = this.selectedReason();
    return this.serviceFieldsFor(node ? node.value : '');
  };

  /* Quello che il cliente ha gia' scritto resta in memoria anche se cambia
     esigenza: tornando indietro ritrova i suoi valori. Nel payload finisce
     comunque solo cio' che appartiene all'intervento scelto. */
  Booking.prototype.captureServiceState = function () {
    var self = this;
    qa(this.root, '[data-service-input]').forEach(function (i) { self.serviceState[i.dataset.serviceInput] = i.value; });
    qa(this.root, '[data-service-skip]').forEach(function (i) { self.serviceState[i.dataset.serviceSkip] = i.checked; });
    qa(this.root, '[data-service-choice]:checked').forEach(function (i) { self.serviceState[i.dataset.serviceChoice] = i.value; });
  };

  Booking.prototype.renderServiceFields = function () {
    var box = q(this.root, '[data-service-fields]');
    if (!box) return;
    this.captureServiceState();

    var self = this;
    /* I campi nascosti non si disegnano: il loro valore lo imposta start() e
       vive in serviceState, non nel DOM. Restano comunque campi veri, con le
       stesse regole di pertinenza e la stessa validazione lato server. */
    var fields = this.currentServiceFields().filter(function (f) { return f.hidden !== true; });
    if (!fields.length) {
      box.innerHTML = '';
      box.hidden = true;
      return;
    }

    var uid = this.fieldUid;
    box.innerHTML = fields.map(function (field) {
      var id = 'bc-sf-' + escapeHtml(field.key) + '-' + uid;
      var helpId = id + '-help';
      var req = field.required ? ' <span class="bc-ofb__req" aria-hidden="true">*</span>' : '';

      if (field.type === 'choice') {
        var name = 'sf_' + field.key + '_' + uid;
        var picked = clean(self.serviceState[field.key]);
        return '<fieldset class="bc-ofb__service-field bc-ofb__service-field--choice">'
          + '<legend>' + escapeHtml(field.label) + req + '</legend>'
          + (clean(field.help) ? '<small class="bc-ofb__service-help">' + escapeHtml(field.help) + '</small>' : '')
          + '<div class="bc-ofb__segmented">' + (field.choices || []).map(function (choice) {
            return '<label class="bc-ofb__segment"><input type="radio" name="' + escapeHtml(name) + '"'
              + ' data-service-choice="' + escapeHtml(field.key) + '" value="' + escapeHtml(choice.value) + '"'
              + (picked === choice.value ? ' checked' : '') + '>'
              + '<span class="bc-ofb__segment-body">'
              + '<span class="bc-ofb__choice-check" aria-hidden="true"></span>'
              + '<span class="bc-ofb__segment-text"><strong>' + escapeHtml(choice.label) + '</strong>'
              + (clean(choice.hint) ? '<small>' + escapeHtml(choice.hint) + '</small>' : '')
              + '</span></span></label>';
          }).join('') + '</div></fieldset>';
      }

      var value = clean(self.serviceState[field.key]);
      var skipped = field.skip_key ? self.serviceState[field.skip_key] === true : false;
      return '<div class="bc-ofb__service-field">'
        + '<label for="' + id + '">' + escapeHtml(field.label) + req + '</label>'
        + '<input id="' + id + '" type="text" data-service-input="' + escapeHtml(field.key) + '"'
        + ' maxlength="' + (Number(field.max_length) || 60) + '"'
        + ' value="' + escapeHtml(value) + '"'
        + (clean(field.placeholder) ? ' placeholder="' + escapeHtml(field.placeholder) + '"' : '')
        + (clean(field.help) ? ' aria-describedby="' + helpId + '"' : '')
        + (skipped ? ' disabled' : '')
        + ' autocomplete="off" autocapitalize="characters" spellcheck="false">'
        + (clean(field.help) ? '<small id="' + helpId + '">' + escapeHtml(field.help) + '</small>' : '')
        + (field.skip_key
          ? '<label class="bc-ofb__service-skip"><input type="checkbox" data-service-skip="' + escapeHtml(field.skip_key) + '"'
            + ' data-service-skip-for="' + escapeHtml(field.key) + '"' + (skipped ? ' checked' : '') + '>'
            + '<span>' + escapeHtml(field.skip_label) + '</span></label>'
          : '')
        + '</div>';
    }).join('');
    box.hidden = false;

    qa(box, '[data-service-input]').forEach(function (i) {
      i.addEventListener('input', function () { self.updateReasonGate(); });
      /* Stessa regola del gestionale, applicata quando il cliente lascia il
         campo: cosi' nel riepilogo legge la misura come verra' registrata.
         Se il valore non e' riconoscibile resta quello che ha scritto. */
      var field = fields.filter(function (f) { return f.key === i.dataset.serviceInput; })[0];
      if (field && field.normalize === 'tire_size') {
        i.addEventListener('blur', function () { i.value = normalizeTireSize(i.value); });
      }
    });
    qa(box, '[data-service-choice]').forEach(function (i) {
      i.addEventListener('change', function () { self.updateReasonGate(); });
    });
    /* "Non conosco la misura" spegne il campo invece di nasconderlo: resta
       visibile il motivo per cui non serve piu' compilarlo. */
    qa(box, '[data-service-skip]').forEach(function (i) {
      i.addEventListener('change', function () {
        var input = q(box, '[data-service-input="' + i.dataset.serviceSkipFor + '"]');
        if (input) input.disabled = i.checked;
        self.updateReasonGate();
      });
    });
  };

  /* Valori da inviare: solo quelli dei campi pertinenti all'esigenza scelta,
     letti dal DOM corrente. Un dato rimasto in memoria da una scelta
     precedente non entra qui. */
  Booking.prototype.serviceData = function () {
    var self = this;
    var data = {};
    this.currentServiceFields().forEach(function (field) {
      if (field.hidden === true) {
        /* Campo non disegnato: il valore sta in memoria. Si manda solo se e'
           uno dei codici previsti, cosi' un valore rimasto da una scelta
           precedente non viaggia travestito da scelta attuale. */
        var stored = clean(self.serviceState[field.key]);
        var known = (field.choices || []).some(function (c) { return c.value === stored; });
        if (field.type === 'choice' ? known : stored !== '') data[field.key] = stored;
        return;
      }
      if (field.type === 'choice') {
        var picked = q(self.root, '[data-service-choice="' + field.key + '"]:checked');
        if (picked) data[field.key] = picked.value;
        return;
      }
      var skip = field.skip_key ? q(self.root, '[data-service-skip="' + field.skip_key + '"]') : null;
      if (skip && skip.checked) {
        data[field.key] = '';
        data[field.skip_key] = true;
        return;
      }
      var input = q(self.root, '[data-service-input="' + field.key + '"]');
      var value = input ? clean(input.value) : '';
      if (value && field.normalize === 'tire_size') value = normalizeTireSize(value);
      if (value) {
        data[field.key] = value;
        if (field.skip_key) data[field.skip_key] = false;
      }
    });
    return data;
  };

  /* Righe per il riepilogo: etichette in chiaro, solo i campi pertinenti. */
  Booking.prototype.serviceDataRows = function () {
    var data = this.serviceData();
    var rows = [];
    this.currentServiceFields().forEach(function (field) {
      /* I campi nascosti servono all'officina, non al cliente: nel riepilogo
         il problema che ha segnalato glielo ricorda gia' il passaggio 1. */
      if (field.hidden === true) return;
      if (field.type === 'choice') {
        var picked = (field.choices || []).filter(function (c) { return c.value === data[field.key]; })[0];
        if (picked) rows.push([field.label, picked.label]);
        return;
      }
      if (field.skip_key && data[field.skip_key] === true) {
        rows.push([field.label, field.skip_value_label || 'Da verificare']);
      } else if (clean(data[field.key])) {
        rows.push([field.label, data[field.key]]);
      }
    });
    return rows;
  };

  /* Il passaggio 1 e' completo quando c'e' un'esigenza e, per gli interventi
     che li prevedono, i campi obbligatori collegati. */
  Booking.prototype.reasonStepReady = function () {
    if (!this.selectedReason()) return false;
    var data = this.serviceData();
    return this.currentServiceFields().every(function (field) {
      if (!field.required) return true;
      if (field.type === 'choice') return !!clean(data[field.key]);
      if (field.skip_key && data[field.skip_key] === true) return true;
      return !!clean(data[field.key]);
    });
  };

  /* Nasconde le card delle esigenze non elencate in visible_reasons. Si
     nasconde la <label> (display:none), non l'input: un radio nascosto non
     e' focalizzabile ne' cliccabile, ma resta selezionabile da codice e
     continua a valere per :checked, quindi il payload non cambia. */
  Booking.prototype.applyReasonVisibility = function () {
    if (!this.visibleReasons.length) return;
    var allowed = this.visibleReasons;
    qa(this.root, 'input[name="reason"]').forEach(function (input) {
      if (allowed.indexOf(input.value) !== -1) return;
      var label = input.closest('label');
      if (!label) return;
      label.hidden = true;
      label.setAttribute('aria-hidden', 'true');
      input.tabIndex = -1;
    });
  };

  Booking.prototype.updateReasonGate = function () {
    q(this.panels[0], '[data-next]').disabled = !this.reasonStepReady();
  };

  /*
   * Passaggio 3 premium: stessi input (type, name, value, checked) del
   * markup classico, cambia solo il contenitore visivo. Cosi' extras(),
   * channel() e il payload non sanno nemmeno che la grafica e' diversa.
   */
  var CHANNEL_ICONS = {
    email: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m4 7 8 6 8-6"/></svg>',
    whatsapp: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 20.5l1.3-4A8.5 8.5 0 1 1 8.4 19.4Z"/><path d="M9.2 8.6c.2-.5.5-.5.8-.5h.5c.2 0 .4.1.5.4l.6 1.5c.1.2 0 .4-.1.6l-.5.6c-.1.1-.1.3 0 .5.5.9 1.4 1.9 2.6 2.5.2.1.4.1.5-.1l.6-.7c.2-.2.4-.2.6-.1l1.5.7c.2.1.4.3.4.5 0 .6-.3 1.3-.9 1.6-.6.4-1.3.4-2 .2a8 8 0 0 1-4.6-4.2c-.4-.9-.4-1.9-.5-3.5Z"/></svg>'
  };
  function channelIcon(code) {
    if (code === 'both') return CHANNEL_ICONS.email + CHANNEL_ICONS.whatsapp;
    return CHANNEL_ICONS[code] || CHANNEL_ICONS.email;
  }

  Booking.prototype.channelCardsMarkup = function (channelList) {
    return '<legend class="bc-ofb__channel-legend">Dove vuoi ricevere le comunicazioni?</legend>'
      + '<div class="bc-ofb__channel-cards">' + channelList.map(function (channel, index) {
        return '<label class="bc-ofb__channel-card">'
          + '<input type="radio" name="channel" value="' + escapeHtml(channel.code) + '"' + (index === 0 ? ' checked' : '')
          + ' data-requires-phone="' + (channel.requires_phone ? '1' : '0') + '">'
          + '<span class="bc-ofb__channel-card-body">'
          + '<span class="bc-ofb__choice-check" aria-hidden="true"></span>'
          + '<span class="bc-ofb__channel-icons" aria-hidden="true">' + channelIcon(channel.code) + '</span>'
          + '<span class="bc-ofb__channel-label">' + escapeHtml(channel.label) + '</span>'
          + '</span></label>';
      }).join('') + '</div>';
  };

  /* Un extra appena selezionato deseleziona gli altri del suo gruppo
     esclusivo (es. lavaggio esterno / completo). Si agisce sul checkbox
     reale, quindi stato, accessibilita' e payload restano coerenti. */
  Booking.prototype.applyExtrasExclusion = function (changed) {
    if (!changed || !changed.checked) return;
    var group = EXTRAS_EXCLUSIVE_GROUPS.filter(function (g) { return g.indexOf(changed.value) !== -1; })[0];
    if (!group) return;
    qa(this.root, 'input[name="extras"]:checked').forEach(function (other) {
      if (other !== changed && group.indexOf(other.value) !== -1) other.checked = false;
    });
  };

  Booking.prototype.extrasCardsMarkup = function (extraList) {
    var self = this;
    var meta = this.meta.extras || {};
    return '<legend class="bc-ofb__sr-only">Servizi aggiuntivi</legend>'
      + '<div class="bc-ofb__extras-cards">' + extraList.map(function (extra) {
        var media = meta[extra.code];
        var price = self.extraPrice(extra.code);
        /* PNG scontornati: nessun riquadro, solo l'immagine appoggiata sulla card. */
        var visual = media && clean(media.src)
          ? '<span class="bc-ofb__extra-media"><img src="' + escapeHtml(media.src) + '"'
            + (clean(media.srcset) ? ' srcset="' + escapeHtml(media.srcset) + '" sizes="(max-width: 749px) 72px, 96px"' : '')
            + ' alt="' + escapeHtml(media.alt) + '" width="320" height="320" loading="lazy" decoding="async"></span>'
          : '';
        return '<label class="bc-ofb__extra-card' + (visual ? ' bc-ofb__extra-card--media' : '') + '">'
          + '<input type="checkbox" name="extras" value="' + escapeHtml(extra.code) + '">'
          + '<span class="bc-ofb__extra-card-body">'
          + '<span class="bc-ofb__choice-check bc-ofb__choice-check--square" aria-hidden="true"></span>'
          + visual
          + '<span class="bc-ofb__extra-text"><strong>' + escapeHtml(extra.label) + '</strong>'
          + (clean(extra.hint) ? '<small>' + escapeHtml(extra.hint) + '</small>' : '')
          + (price !== null ? '<b class="bc-ofb__extra-price">+ ' + escapeHtml(euro(price)) + '</b>' : '')
          + '</span></span></label>';
      }).join('') + '</div>';
  };

  /* Riepilogo in cima al passaggio 3: mostra solo cio' che e' davvero stato
     scelto (esigenza, giorno, orario); una riga senza dato resta nascosta. */
  Booking.prototype.renderRecap = function () {
    var recap = q(this.root, '[data-recap]');
    if (!recap) return;
    var reason = this.reasonData();
    var date = q(this.root, '[data-date]').value;
    var start = this.slot ? clean(this.slot.start_time || this.slot.start) : '';
    var values = {
      reason: reason ? clean(reason.label) : '',
      date: date ? prettyDate(date).replace(/^./, function (c) { return c.toUpperCase(); }) : '',
      time: start
    };
    var any = false;
    Object.keys(values).forEach(function (key) {
      var row = q(recap, '[data-recap-row="' + key + '"]');
      var cell = q(recap, '[data-recap-' + key + ']');
      if (!row || !cell) return;
      cell.textContent = values[key];
      row.hidden = !values[key];
      if (values[key]) any = true;
    });
    var empty = q(recap, '[data-recap-empty]');
    if (empty) empty.hidden = any;
  };

  Booking.prototype.selectedReason = function () { return q(this.root, 'input[name="reason"]:checked'); };
  Booking.prototype.reasonData = function () {
    var node = this.selectedReason();
    if (!node || !this.options) return null;
    var code = node.value;
    return this.options.reasons.filter(function (r) { return r.code === code; })[0] || null;
  };
  Booking.prototype.channel = function () {
    var n = q(this.root, 'input[name="channel"]:checked');
    return n ? n.value : 'email';
  };
  Booking.prototype.channelData = function () {
    var code = this.channel();
    var list = (this.options && this.options.channels) || [];
    return list.filter(function (c) { return c.code === code; })[0] || { code: code, label: 'Email', automatic: true };
  };
  Booking.prototype.extras = function () {
    return qa(this.root, 'input[name="extras"]:checked').map(function (n) { return n.value; });
  };
  Booking.prototype.extraLabels = function () {
    var codes = this.extras();
    var list = (this.options && this.options.extras) || [];
    return list.filter(function (e) { return codes.indexOf(e.code) !== -1; }).map(function (e) { return e.label; });
  };
  /* Extra selezionati con il prezzo di listino (null se non configurato) e
     totale dei soli extra prezzati. Solo per il riepilogo: nulla di questo
     viene inviato al gestionale. */
  Booking.prototype.extrasWithPrices = function () {
    var self = this;
    var codes = this.extras();
    var list = (this.options && this.options.extras) || [];
    var items = list.filter(function (e) { return codes.indexOf(e.code) !== -1; }).map(function (e) {
      return { code: e.code, label: e.label, price: self.extraPrice(e.code) };
    });
    var total = items.reduce(function (sum, item) { return sum + (item.price || 0); }, 0);
    return { items: items, total: Math.round(total * 100) / 100 };
  };

  Booking.prototype.renderScopeNote = function () {
    var note = q(this.root, '[data-scope-note]');
    if (!note) return;
    var reason = this.reasonData();
    if (!reason) { note.hidden = true; note.textContent = ''; return; }

    var lines = [];
    /* Esigenza a prezzo noto (la diagnosi freni): la cifra e la condizione si
       dicono qui, al momento della scelta, non alla cassa. */
    if (Number(reason.price_eur) > 0) {
      lines.push('Questo servizio costa ' + euro(reason.price_eur) + '.'
        + (clean(reason.price_note) ? ' ' + clean(reason.price_note) : ''));
    }
    if (reason.scope === 'inspection') {
      /* Il controllo non e' gratuito e non copre la riparazione: dirlo prima
         evita che il cliente si aspetti un prezzo che nessuno puo' dare
         senza aver visto l'auto. */
      lines.push(Number(reason.price_eur) > 0
        ? 'Il preventivo dell eventuale intervento arriva dopo la diagnosi: procediamo solo dopo la tua approvazione.'
        : 'Per questa richiesta prepareremo il preventivo del controllo o della diagnosi. Se emergeranno lavori da fare, riceverai un secondo preventivo e procederemo solo dopo la tua approvazione.');
    }
    /* Problema da cui e' partito il cliente: glielo si rimanda indietro per
       conferma, cosi' si accorge subito se ha cliccato la card sbagliata. */
    var symptom = this.hiddenFieldLabel('brake_symptom') || this.hiddenFieldLabel('brake_symptom_detail');
    if (symptom) lines.push('Problema segnalato: ' + symptom + '.');

    note.textContent = lines.join(' ');
    note.hidden = lines.length === 0;
  };

  /* Etichetta in chiaro di un campo nascosto gia' valorizzato, se pertinente
     all'esigenza scelta. Serve solo a mostrarla: il valore inviato resta il
     codice. */
  Booking.prototype.hiddenFieldLabel = function (key) {
    var self = this;
    var field = this.currentServiceFields().filter(function (f) { return f.key === key && f.hidden === true; })[0];
    if (!field) return '';
    var stored = clean(self.serviceState[key]);
    var choice = (field.choices || []).filter(function (c) { return c.value === stored; })[0];
    return choice ? choice.label : '';
  };

  Booking.prototype.updateChannel = function () {
    var data = this.channelData();
    var phone = this.form.elements.phone;
    phone.required = !!data.requires_phone;
    var note = q(this.root, '[data-channel-note]');
    if (note) {
      note.textContent = data.automatic
        ? 'Riceverai una email con il preventivo in allegato appena l officina lo prepara.'
        : 'Riceverai il preventivo su WhatsApp direttamente dal nostro team: ti contatteremo entro poche ore.';
    }
  };

  Booking.prototype.next = function () {
    this.clearAlert();
    if (this.step === 0 && !this.selectedReason()) { this.alert('Scegli il motivo della richiesta.'); return; }
    if (this.step === 0 && !this.reasonStepReady()) {
      this.alert('Completa le informazioni richieste per l intervento scelto.');
      var missing = q(this.root, '[data-service-fields] input:not([disabled])');
      if (missing) missing.focus();
      return;
    }
    if (this.step === 1 && !this.slot) { this.alert('Scegli un orario disponibile.'); return; }
    if (this.step === 2 && !this.validateDetails()) return;
    if (this.step === 2) {
      /* L'orario puo' essere stato annullato dopo la scelta (un extra che
         cambia la durata fa ricaricare la disponibilita'): meglio riportare
         indietro con un messaggio che mostrare un riepilogo senza orario. */
      if (!this.slot) {
        this.go(1);
        this.alert('Scegli di nuovo l orario: i servizi aggiuntivi selezionati cambiano la durata dell appuntamento.');
        return;
      }
      this.renderSummary();
    }
    this.go(Math.min(3, this.step + 1));
  };

  Booking.prototype.go = function (index) {
    /* Il passaggio della scelta, quando e' fuori dal percorso, non si
       raggiunge piu' da nessuna strada: ne' "Indietro", ne' "Modifica" del
       riepilogo, ne' un rientro dopo un errore. */
    index = Math.max(this.minStep(), index);
    this.goingBack = index < this.step;
    this.step = index;
    var name = this.steps[index];
    if (name === 'schedule') this.renderServiceBadge();
    if (name === 'details') this.renderRecap();
    if (this.wizard) this.root.classList.toggle('is-going-back', this.goingBack);
    this.panels.forEach(function (p) {
      var active = p.dataset.panel === name;
      p.hidden = !active;
      p.classList.toggle('is-active', active);
    });
    qa(this.root, '[data-progress]').forEach(function (li, i) {
      li.classList.toggle('is-active', i === index);
      li.classList.toggle('is-done', i < index);
      if (i === index) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
    this.clearAlert();

    if (!this.wizard) {
      /* Comportamento storico degli altri servizi officina: invariato. */
      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    /* In modalita' wizard il pannello entra di lato e la pagina si riallinea
       in un fotogramma: lo scorrimento morbido raddoppierebbe il movimento. */
    snapIntoView(this.root);
    this.focusStep();
  };

  /*
   * Porta il focus sul titolo del passaggio appena entrato.
   *
   * Senza, chi naviga da tastiera resterebbe col focus sul pulsante premuto,
   * che ora e' in una schermata che non si vede piu'. tabindex="-1" rende il
   * titolo focalizzabile da codice ma non raggiungibile col tab, cosi' non si
   * aggiunge una tappa in piu' a chi usa il mouse.
   */
  Booking.prototype.focusStep = function () {
    var panel = q(this.root, '[data-panel="' + this.steps[this.step] + '"]');
    var title = panel ? q(panel, 'h2') : null;
    if (!title) return;
    title.setAttribute('tabindex', '-1');
    title.focus({ preventScroll: true });
  };

  Booking.prototype.validateDetails = function () {
    this.updateChannel();
    var plate = this.form.elements.plate;
    plate.value = clean(plate.value).toUpperCase().replace(/[^A-Z0-9]/g, '');
    /* Stessa regola del gestionale: almeno 5 caratteri alfanumerici. */
    if (plate.value.length < 5) {
      this.alert('Inserisci una targa valida di almeno 5 caratteri (solo lettere e numeri).');
      plate.focus();
      return false;
    }
    if (this.channelData().requires_phone && clean(this.form.elements.phone.value) === '') {
      this.alert('Per ricevere il messaggio su WhatsApp serve il tuo numero di telefono.');
      this.form.elements.phone.focus();
      return false;
    }
    var fields = ['first_name', 'last_name', 'email', 'plate', 'vehicle_make_model'];
    for (var i = 0; i < fields.length; i++) {
      var f = this.form.elements[fields[i]];
      if (!f.checkValidity()) { f.reportValidity(); return false; }
    }
    if (!this.form.elements.privacy.checked) { this.form.elements.privacy.reportValidity(); return false; }
    return true;
  };

  Booking.prototype.extraMinutes = function () {
    var codes = this.extras();
    var list = (this.options && this.options.extras) || [];
    return list.reduce(function (total, extra) {
      return codes.indexOf(extra.code) !== -1 ? total + (Number(extra.extra_minutes) || 0) : total;
    }, 0);
  };

  /*
   * Un extra conta sugli orari solo se allunga il lavoro. Finche' i minuti
   * totali non cambiano, la disponibilita' e' la stessa e non va ricaricata:
   * ricaricarla comunque cancellerebbe l'orario gia' scelto dal cliente,
   * senza motivo e senza dirglielo.
   */
  Booking.prototype.onExtrasChanged = function () {
    var minutes = this.extraMinutes();
    if (minutes === this.appliedExtraMinutes) return;
    this.appliedExtraMinutes = minutes;

    var date = q(this.root, '[data-date]').value;
    if (!date) return;

    var hadSlot = !!this.slot;
    this.loadSlots(date);
    if (hadSlot) {
      this.alert('I servizi aggiuntivi cambiano la durata dell appuntamento: scegli di nuovo l orario.');
    }
  };

  Booking.prototype.availabilityPath = function (date) {
    var path = '/availability.php?service_slug=' + encodeURIComponent(this.slug) + '&date=' + encodeURIComponent(date);
    var extras = this.extras();
    if (extras.length) path += '&extras=' + encodeURIComponent(extras.join(','));
    return path;
  };

  Booking.prototype.loadSlots = async function (date) {
    this.slot = null;
    q(this.panels[1], '[data-next]').disabled = true;
    var area = q(this.root, '[data-slots]');
    var dateLabel = q(this.root, '[data-slots-date]');
    if (dateLabel) { var pretty = date ? prettyDate(date) : ''; dateLabel.textContent = pretty ? pretty.charAt(0).toUpperCase() + pretty.slice(1) : 'Nessun giorno selezionato'; }
    if (!date) { area.innerHTML = '<p class="bc-ofb__hint">' + escapeHtml(this.msgPickDate) + '</p>'; return; }
    var parts = date.split('-');
    var day = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])).getDay();
    var isoDay = day === 0 ? 7 : day;
    if (this.closed.indexOf(isoDay) !== -1) {
      area.innerHTML = '<p class="bc-ofb__hint">L officina e chiusa nel giorno scelto. Seleziona un altro giorno.</p>';
      return;
    }
    this.setLoading(true);
    this.clearAlert();
    try {
      var data = await this.api(this.availabilityPath(date));
      if (data.effective_duration_minutes != null) this.renderDuration(data.effective_duration_minutes);
      this.renderSlots(Array.isArray(data.slots) ? data.slots : []);
    } catch (e) {
      area.innerHTML = '<p class="bc-ofb__hint">Disponibilita non caricata.</p>';
      this.alert(this.errorMessage(e));
    } finally {
      this.setLoading(false);
    }
  };

  Booking.prototype.renderSlots = function (slots) {
    var self = this;
    var area = q(this.root, '[data-slots]');
    if (!slots.length) {
      area.innerHTML = '<p class="bc-ofb__hint">' + escapeHtml(this.msgNoSlots) + '</p>';
      return;
    }
    area.innerHTML = slots.map(function (s, i) {
      var start = clean(s.start_time || s.start);
      var end = clean(s.end_time || s.end);
      return '<button type="button" class="bc-ofb__slot" data-slot="' + i + '" aria-pressed="false">'
        + escapeHtml(clean(s.display_label) || start + (end ? ' – ' + end : '')) + '</button>';
    }).join('');
    qa(area, '[data-slot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qa(area, '[data-slot]').forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        self.slot = slots[Number(btn.dataset.slot)];
        q(self.panels[1], '[data-next]').disabled = false;
      });
    });
  };

  Booking.prototype.renderSummary = function () {
    var reason = this.reasonData();
    var date = q(this.root, '[data-date]').value;
    var start = clean(this.slot.start_time || this.slot.start);
    var extras = this.extrasWithPrices();
    var channel = this.channelData();

    q(this.root, '[data-outcome]').textContent = (reason && reason.scope === 'inspection')
      ? 'Confermeremo l appuntamento e ti invieremo il preventivo del controllo o della diagnosi.'
      : 'Confermeremo l appuntamento e ti invieremo il preventivo dell intervento richiesto.';

    var rows = [
      ['Richiesta', reason ? reason.label : '']
    ];
    /* Prezzo del servizio scelto, quando esiste: l'ultima schermata prima
       dell'invio e' il posto in cui il cliente si aspetta di rileggerlo. */
    if (reason && Number(reason.price_eur) > 0) {
      rows.push(['Prezzo del servizio', euro(reason.price_eur)
        + (clean(reason.price_note) ? ' · ' + clean(reason.price_note) : '')]);
    }
    rows = rows.concat(this.serviceDataRows()).concat([
      ['Data', prettyDate(date)],
      ['Orario', start],
      ['Auto', clean(this.form.elements.vehicle_make_model.value) + ' · ' + clean(this.form.elements.plate.value).toUpperCase()],
      ['Contatto', channel.label]
    ]);
    var html = rows.map(function (r) {
      return '<dt>' + escapeHtml(r[0]) + '</dt><dd>' + escapeHtml(r[1]) + '</dd>';
    }).join('');
    /* Servizi aggiuntivi: una riga per servizio con il prezzo di listino e,
       se almeno uno ha un prezzo, il totale dei soli extra. Il preventivo
       del servizio principale resta separato e lo fa l'officina. */
    if (!extras.items.length) {
      html += '<dt>Aggiunte</dt><dd>Nessuna</dd>';
    } else {
      html += '<dt>Aggiunte</dt><dd><ul class="bc-ofb__summary-extras">' + extras.items.map(function (item) {
        return '<li><span>' + escapeHtml(item.label) + '</span>'
          + (item.price !== null ? '<b>' + escapeHtml(euro(item.price)) + '</b>' : '')
          + '</li>';
      }).join('') + '</ul></dd>';
      if (extras.total > 0) {
        html += '<dt>Totale servizi aggiuntivi</dt><dd><b class="bc-ofb__summary-total">' + escapeHtml(euro(extras.total)) + '</b>'
          + '<small class="bc-ofb__summary-note">IVA inclusa · escluso il preventivo del servizio principale</small></dd>';
      }
    }
    q(this.root, '[data-summary]').innerHTML = html;
  };

  /* Ultimo controllo prima dell'invio: fra la scelta e la conferma qualcun
     altro puo' aver preso lo stesso orario. */
  Booking.prototype.recheck = async function () {
    var date = q(this.root, '[data-date]').value;
    var start = clean(this.slot.start_time || this.slot.start);
    var data = await this.api(this.availabilityPath(date));
    var slots = Array.isArray(data.slots) ? data.slots : [];
    var found = slots.filter(function (s) { return clean(s.start_time || s.start) === start; })[0];
    if (!found) {
      var e = new Error();
      e.code = 'slot_not_available';
      throw e;
    }
    this.slot = found;
  };

  /* ---------- Invio: strati a tutto schermo e schermata finale ----------
   *
   * Stesso framework del flusso Tagliando: gli strati vivono fuori dalla
   * sezione, la pagina si blocca come li', e il caricamento sfuma sopra la
   * schermata finale gia' montata. Qui cambiano solo testi, icona e accenti.
   */

  /* Millisecondi minimi di permanenza del caricamento: se il gestionale
     risponde prima si aspetta comunque, se risponde dopo la schermata finale
     compare solo alla risposta reale. Stesso valore del Tagliando. */
  var SENDING_MIN_MS = 2000;

  /**
   * Sposta gli strati a tutto schermo in un contenitore figlio di <body>.
   *
   * Dentro la sezione dipenderebbero da tutti i suoi antenati: basta che il
   * tema aggiunga a uno di essi un transform, un filter, un contain o un
   * will-change e position: fixed smette di riferirsi allo schermo. Il
   * markup resta uno solo, nel Liquid: qui viene soltanto spostato.
   */
  Booking.prototype.mountLayers = function () {
    var layers = qa(this.root, '[data-fs-layer]');
    if (!layers.length || !document.body) return;
    var key = clean(this.root.dataset.sectionId) || this.fieldUid;
    /* Una sezione ricaricata dall'editor del tema non deve lasciare dietro
       di se' il contenitore della volta precedente. */
    qa(document, '.bc-ofb-layers').forEach(function (host) {
      if (host.getAttribute('data-bc-layers-for') === key) host.remove();
    });
    var host = document.createElement('div');
    host.className = 'bc-ofb-layers';
    host.setAttribute('data-bc-layers-for', key);
    layers.forEach(function (layer) { host.appendChild(layer); });
    document.body.appendChild(host);
    this.layerHost = host;
  };

  /* Gli strati si aprono e si chiudono sempre da qui: una sola gestione
     dello scroll e dell'inerzia del modulo sottostante. */
  Booking.prototype.showFullscreen = function (layer) {
    if (!layer) return;
    layer.hidden = false;
    this.lockPageScroll(true);
    this.setBackgroundInert(true);
  };

  /* Lo scroll e il modulo tornano disponibili solo quando non resta aperto
     nessun altro strato: nel passaggio dal caricamento alla schermata finale
     la pagina non deve mai tornare libera. */
  Booking.prototype.hideFullscreen = function (layer) {
    if (layer) layer.hidden = true;
    if (this.layerHost && this.layerHost.querySelector('[data-fs-layer]:not([hidden])')) return;
    this.lockPageScroll(false);
    this.setBackgroundInert(false);
  };

  /* Con uno strato aperto il modulo sottostante non deve ricevere ne' focus
     ne' clic: e' cio' che aria-modal promette agli screen reader. Vale solo
     quando gli strati sono stati spostati fuori dalla sezione, altrimenti
     inert li renderebbe inutilizzabili insieme al modulo. */
  Booking.prototype.setBackgroundInert = function (inert) {
    if (!this.layerHost) return;
    if (inert) {
      this.root.setAttribute('inert', '');
      this.root.setAttribute('aria-hidden', 'true');
      return;
    }
    this.root.removeAttribute('inert');
    this.root.removeAttribute('aria-hidden');
  };

  /**
   * Blocco dello scroll della pagina mentre uno strato e' aperto.
   *
   * overflow: hidden su <html> da solo non basta: Safari iOS continua a far
   * scorrere la pagina sotto il dito, e con la pagina si muove la barra degli
   * indirizzi, che cambia l'altezza visibile e puo' scoprire il fondo dello
   * schermo. Il corpo viene fissato esattamente dov'e': per chi guarda non si
   * muove niente, e al rilascio si torna allo stesso punto.
   */
  Booking.prototype.lockPageScroll = function (locked) {
    var html = document.documentElement;
    var body = document.body;
    var keys = ['position', 'top', 'left', 'right', 'width', 'overflow'];
    if (locked) {
      if (this.scrollLocked || !body) return;
      this.lockedScrollY = window.pageYOffset || html.scrollTop || 0;
      this.previousOverflow = html.style.overflow;
      this.previousBodyStyle = {};
      keys.forEach(function (key) { this.previousBodyStyle[key] = body.style[key]; }, this);
      html.style.overflow = 'hidden';
      body.style.position = 'fixed';
      body.style.top = (-this.lockedScrollY) + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      this.scrollLocked = true;
      return;
    }
    if (!this.scrollLocked) return;
    var previous = this.previousBodyStyle || {};
    keys.forEach(function (key) { body.style[key] = previous[key] || ''; });
    html.style.overflow = this.previousOverflow || '';
    this.previousBodyStyle = null;
    this.scrollLocked = false;
    window.scrollTo(0, this.lockedScrollY);
  };

  Booking.prototype.showSubmitting = function () {
    this.showFullscreen(this.fs.sending);
  };

  Booking.prototype.hideSubmitting = function () {
    this.hideFullscreen(this.fs.sending);
  };

  /* Dissolvenza del caricamento sopra la schermata finale gia' montata: fra
     i due strati non deve comparire un fotogramma del modulo sottostante. */
  Booking.prototype.fadeOutSubmitting = function () {
    var self = this;
    var layer = this.fs.sending;
    if (!layer) return;
    layer.classList.add('is-leaving');
    var done = false;
    var once = function () {
      if (done) return;
      done = true;
      layer.classList.remove('is-leaving');
      self.hideFullscreen(layer);
    };
    /* transitionend puo' non arrivare (movimento ridotto, scheda in secondo
       piano): il timer chiude comunque. */
    layer.addEventListener('transitionend', once, { once: true });
    setTimeout(once, 400);
  };

  /* Schermata finale: richiesta ricevuta, in attesa del preventivo. Il codice
     e' quello restituito dal gestionale: se manca, il box resta nascosto
     (mai inventato). */
  Booking.prototype.showSuccess = function (code) {
    var layer = this.fs.done;
    this.panels.forEach(function (p) { p.hidden = true; });
    if (this.fs.code) this.fs.code.textContent = clean(code);
    if (this.fs.codeBox) this.fs.codeBox.hidden = !clean(code);
    /* Dove arrivera' il preventivo lo ha deciso il cliente al passaggio 3:
       la schermata finale dice quello, non sempre "controlla l'email". */
    var byEmail = this.channelData().automatic !== false;
    if (this.fs.mailEmail) this.fs.mailEmail.hidden = !byEmail;
    if (this.fs.mailWhatsapp) this.fs.mailWhatsapp.hidden = byEmail;
    qa(this.root, '[data-progress]').forEach(function (li) { li.classList.remove('is-active'); li.classList.add('is-done'); });
    if (!layer) return;
    this.showFullscreen(layer);
    layer.scrollTop = 0;
    try { layer.focus({ preventScroll: true }); } catch (e) { layer.focus(); }
    this.fadeOutSubmitting();
  };

  Booking.prototype.submit = async function () {
    /* Un solo invio per richiesta: dopo il successo il form non si rimanda. */
    if (this.submitting || this.completed) return;
    this.clearAlert();
    this.submitting = true;
    var button = q(this.root, '[data-submit]');
    var old = button.textContent;
    button.disabled = true;
    button.textContent = 'Invio in corso…';
    /* L'overlay parte insieme all'invio reale e resta almeno SENDING_MIN_MS:
       il tempo si misura da qui, non da un timer indipendente dalla rete. */
    var startedAt = performance.now();
    this.showSubmitting();

    try {
      if (!this.validateDetails()) { this.go(2); this.validateDetails(); return; }
      await this.recheck();

      var reason = this.reasonData();
      var channel = this.channelData();
      var date = q(this.root, '[data-date]').value;
      var start = clean(this.slot.start_time || this.slot.start);

      /*
       * Il riassunto testuale delle note lo scrive il gestionale a partire
       * da questi codici: qui si mandano solo dati, non frasi.
       */
      var payload = {
        source: 'shopify',
        service_slug: this.slug,
        date: date,
        start_time: start,
        reason_code: reason ? reason.code : '',
        extras: this.extras(),
        contact_channel: channel.code,
        customer_note: clean(this.form.elements.customer_note.value),
        first_name: clean(this.form.elements.first_name.value),
        last_name: clean(this.form.elements.last_name.value),
        email: clean(this.form.elements.email.value),
        phone: clean(this.form.elements.phone.value),
        plate: clean(this.form.elements.plate.value).toUpperCase(),
        vehicle_make_model: clean(this.form.elements.vehicle_make_model.value),
        km: clean(this.form.elements.km.value),
        privacy_consent: true,
        marketing_consent: false,
        shopify_product_id: this.productId,
        idempotency_key: this.key,
        honeypot: clean(this.form.elements.website.value)
      };

      /* Dati specifici dell'intervento: la chiave compare solo quando
         l'esigenza scelta ne prevede davvero. Il server rifiltra comunque
         sull'esigenza validata, quindi un dato non pertinente non passa. */
      var serviceData = this.serviceData();
      if (Object.keys(serviceData).length) payload.service_data = serviceData;

      var data = await this.api('/book.php', { method: 'POST', body: JSON.stringify(payload) });

      /* Risposta positiva reale: si completa solo il minimo visivo residuo. */
      var remaining = SENDING_MIN_MS - (performance.now() - startedAt);
      if (remaining > 0) await new Promise(function (r) { setTimeout(r, remaining); });
      this.completed = true;
      /* Nessun hideSubmitting qui: la schermata finale si monta sotto e il
         caricamento le sfuma sopra, cosi' fra i due strati non si vede il
         modulo. */
      this.showSuccess(clean(data.booking_id || data.appointment_id));
    } catch (e) {
      /* Anche l'errore aspetta il minimo visivo, come nel Tagliando: un
         caricamento che lampeggia non lascia capire niente. Niente successo
         e niente codice: solo il messaggio di errore sul modulo. */
      var left = SENDING_MIN_MS - (performance.now() - startedAt);
      if (left > 0) await new Promise(function (r) { setTimeout(r, left); });
      this.hideSubmitting();
      if (e.code === 'slot_not_available') {
        this.go(1);
        this.loadSlots(q(this.root, '[data-date]').value);
      }
      this.alert(this.errorMessage(e));
    } finally {
      /* A richiesta completata il caricamento se ne va da solo, sfumando
         sopra la schermata finale: chiuderlo qui taglierebbe la dissolvenza
         e per un fotogramma si rivedrebbe il modulo. */
      if (!this.completed) this.hideSubmitting();
      this.submitting = false;
      button.disabled = false;
      button.textContent = old;
    }
  };

  Booking.prototype.api = async function (path, options) {
    if (this.abort) this.abort.abort();
    this.abort = new AbortController();
    var controller = this.abort;
    var timer = setTimeout(function () { controller.abort(); }, 15000);
    var opts = Object.assign({}, options || {});
    opts.mode = 'cors';
    opts.cache = 'no-store';
    opts.signal = controller.signal;
    opts.headers = Object.assign({}, opts.headers || {}, { Accept: 'application/json', 'X-BigCars-Public-Token': this.token });
    if (opts.method === 'POST') opts.headers['Content-Type'] = 'application/json';
    try {
      var res = await fetch(this.apiBase + path, opts);
      var text = await res.text();
      var data = {};
      try { data = text ? JSON.parse(text) : {}; } catch (x) {
        var pe = new Error();
        pe.code = 'invalid_response';
        throw pe;
      }
      if (!res.ok || data.ok === false || data.success === false) {
        var e = new Error(clean(data.error) || 'Errore richiesta');
        e.code = clean(data.code) || 'request_failed';
        throw e;
      }
      return data;
    } catch (e) {
      if (e.name === 'AbortError') e.code = 'network_timeout';
      throw e;
    } finally {
      clearTimeout(timer);
      if (this.abort === controller) this.abort = null;
    }
  };

  Booking.prototype.setLoading = function (on) { q(this.root, '[data-loading]').hidden = !on; };
  Booking.prototype.alert = function (message) {
    var a = q(this.root, '[data-alert]');
    a.textContent = message;
    a.hidden = false;
  };
  Booking.prototype.clearAlert = function () { q(this.root, '[data-alert]').hidden = true; };

  /* Messaggi distinti per dati non validi, slot occupato, timeout ed errore
     del server: il cliente deve capire se riprovare o cambiare qualcosa. */
  Booking.prototype.errorMessage = function (e) {
    if (e && e.code === 'missing_required_field') return e.message || 'Compila tutti i campi obbligatori.';
    return ({
      invalid_token: 'Configurazione del servizio non valida. Contatta B.I.G. Cars.',
      slot_not_available: 'L orario non e piu disponibile. Scegline un altro.',
      network_timeout: 'Il gestionale impiega troppo tempo a rispondere. Riprova.',
      invalid_response: 'Risposta non valida dal gestionale. Riprova tra poco.',
      invalid_email: 'Controlla l indirizzo email.',
      invalid_date: 'La data scelta non e valida.',
      invalid_time: 'L orario scelto non e prenotabile.',
      invalid_reason: 'Il motivo scelto non e piu disponibile: ricarica la pagina.',
      invalid_service: 'Servizio non disponibile online in questo momento.',
      invalid_privacy_consent: 'Devi accettare la privacy policy per inviare la richiesta.',
      rate_limited: 'Troppe richieste. Attendi un minuto e riprova.',
      server_error: 'Il gestionale ha risposto con un errore. Riprova tra poco o contattaci.'
    })[e && e.code] || 'Non siamo riusciti a inviare la richiesta. Riprova tra poco.';
  };

  function boot() {
    qa(document, ROOT).forEach(function (root) {
      if (!root.dataset.bcReady) {
        root.dataset.bcReady = '1';
        new Booking(root);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
